import React, { useEffect } from 'react';
import { Typography, Card, Table } from 'antd';
import AverageTagSmall from '../components/averageTagSmall/averageTagSmall';
import IndividualInformHeader from '../components/individualInformHeader/individualInformHeader';
import LeadershipNPSIndividual from '../components/leadershipNPSIndividual/leadershipNPSIndividual';
import AutoSizeTitle from '../components/autoSizeTitle/AutoSizeTitle';

const { Title } = Typography;

const PageResultsByNpsIndividual = ({
    selectedEvaluation,
    individualResult,
    orgLogo,
    pageNumber,
    title,
    subdimension,
    showNPS,
    totalN
}) => {

    const backgroundStyle = {
        backgroundImage: `url('/informs/pagina.png')`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'left top',
        backgroundSize: '100% auto',
    };

    const getColor = (value) => {
        if (value <= selectedEvaluation.evl_max_red_light) return "#e53935";
        if (value <= selectedEvaluation.evl_max_yellow_light) return "#fbc02d";
        return "#43a047";
    };

    return (
        <div className="pdf-page internal-page">
            <div className="internal-page-content" style={backgroundStyle}>
                {/* Título general */}
                <AutoSizeTitle text={selectedEvaluation.evl_title} />

                {/* Info de colaborador */}
                <div className="internal-page-info" style={{ position: "relative" }}>
                    <IndividualInformHeader individualResult={individualResult} orgLogo={orgLogo} />

                    {/* Promedio general de la subdimension */}
                    {!(selectedEvaluation?.evl_srv_id === 7 && totalN < 3) && (
                        <AverageTagSmall
                            average={subdimension.nps}
                            color={getColor(subdimension.nps)}
                            type={2}
                            isNps={true}
                        />
                    )}

                    <Card
                        style={{
                            border: 'none',
                            backgroundColor: 'white',
                            boxShadow: 'none',
                        }}
                        styles={{ body: { padding: '0' } }}
                    >
                        <Title
                            level={4}
                            style={{ color: '#339C98', marginBottom: 16, width: 'calc(100% - 150px)' }}
                        >
                            {title}
                        </Title>
                        {(selectedEvaluation?.evl_srv_id === 7 && totalN < 3) ? (
                            <div style={{ textAlign: 'center', padding: '20px', backgroundColor: '#fff3cd', border: '1px solid #ffeeba', borderRadius: '8px' }}>
                                <p style={{ color: '#856404', margin: 0, fontSize: '15px' }}>
                                    Fuente insuficiente para calcular NPS — se requieren mínimo 3 evaluadores por fuente.
                                </p>
                            </div>
                        ) : (
                            <LeadershipNPSIndividual
                                average={subdimension.average}
                                nps={subdimension.nps}
                                promoters={subdimension.promoters}
                                neutral={subdimension.neutral}
                                detractors={subdimension.detractors}
                                question={subdimension.question}
                                counts={subdimension.counts}
                                counts_by_relationship={subdimension.counts_by_relationship}
                                detractors_count={subdimension.detractors_count}
                                neutral_count={subdimension.neutral_count}
                                promoters_count={subdimension.promoters_count}
                                showNPS={showNPS}
                            />
                        )}
                    </Card>
                </div>

                {/* Número de página */}
                <div className="internal-page-number">{pageNumber}</div>
            </div>
        </div>
    );
};

export default PageResultsByNpsIndividual;
